import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';

const initialState = { GroupEmps: [], loading: false, error: null, GroupEmp: {} };

export const getGroupEmp = createAsyncThunk('Groups/getGroupEmp', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.get('HRSetting/GetGroupList');
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const AddGroupEmp = createAsyncThunk('Groups/AddGroupEmp', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    // const data = await postData( "HRSetting/AddGroup", item);
    const { data } = await ntxAPI.post('HRSetting/AddGroup', item);
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const updateGroup = createAsyncThunk('Groups/updateGroup', async (item, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.post('HRSetting/UpdateGroup', item);
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const getGroupEmpById = createAsyncThunk('Groups/getGroupEmpById', async (id, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;

  try {
    const { data } = await ntxAPI.get(`HRSetting/GetGroupById?Id=${id}`);
    // debugger
    return data;
  } catch (error) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

const groupSlice = createSlice({
  name: 'Groups',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      /////// get all Group
      .addCase(getGroupEmp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupEmp.fulfilled, (state, action) => {
        state.loading = false;
        state.GroupEmps = action.payload;
      })
      .addCase(getGroupEmp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// get By Id
      .addCase(getGroupEmpById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGroupEmpById.fulfilled, (state, action) => {
        state.loading = false;
        state.GroupEmp = action.payload;
      })
      .addCase(getGroupEmpById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /////// add Group
      .addCase(AddGroupEmp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddGroupEmp.fulfilled, (state, action) => {
        state.loading = false;
        state.GroupEmps.push(action.payload);
      })
      .addCase(AddGroupEmp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default groupSlice.reducer;
